import { ProductOrderViewModel } from '@models/productOrderView';
import { create } from 'zustand';

export interface PaymentStatementModalStore {
  show?: boolean;
  data?: ProductOrderViewModel;
  close: () => boolean;
  open: (data?: ProductOrderViewModel) => void;
}

export const usePaymentStatementModalStore = create<PaymentStatementModalStore>((set, get) => ({
  show: false,
  close: () => {
    const isCloseExecute = !!get().show;
    set({ show: false });
    return isCloseExecute;
  },
  open: (data?: ProductOrderViewModel) => {
    set({ data: data, show: true });
  },
}));
